import Favicon from './Favicon';

export default Favicon;
